/*
 * @Author: wp
 * @Date: 2023-01-03 15:00:55
 * @Descripttion:
 */
import Vue from 'vue'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN'
Vue.use(Element, { locale })
